import styled from 'styled-components';

const GameArticleStarsStyled = styled.section`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: ${props =>
    props.roundResult ? '0 0 calc(10px + 2vmin) 0' : 'calc(15px + 1vmin) 0'};
  justify-content: center;
`;

export const SVGStarStyled = styled.svg`
  fill: ${props =>
    props.stars === 0
      ? props.theme.colors.disabled
      : props.stars === 1 && props.star1
        ? props.theme.colors.yellow
        : props.stars === 2 && (props.star1 || props.star2)
          ? props.theme.colors.yellow
          : props.stars === 3
            ? props.theme.colors.yellow
            : props.theme.colors.disabled};
  height: calc(30px + 3vmin);
  opacity: 0;
  position: relative;
  top: ${props => (props.star2 ? '-2vmin' : '0')};
  transform: translateY(10px);
  transition: opacity ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut},
    transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut};
  transition-delay: ${props =>
    props.star1 ? '0.3s' : props.star2 ? '0.4s' : '0.5s'};
  width: calc(30px + 3vmin);

  .game-enter-done &,
  .result-enter-done & {
    opacity: 1;
    transform: translateY(0);
  }
  .result-enter-done & {
    transition-delay: ${props =>
      props.star1 ? '3s' : props.star2 ? '3.1s' : '3.2s'};
  }
`;

export default GameArticleStarsStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/GameArticleStars/GameArticleStars.styled.js